import { getInitInfo } from '@/apps/index/models/api'
import PaperPending from '@/apps/paper/components/paper-pending'
import { AssessmentAllowSubjects } from '@/common/allow-list'
import { Ranger } from '@/components'
import SmallBtnSkeleton from '@/components/common/small-btn-skeleton'
import { Component, Mixins, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import AssessmentPaper from '../components/assessment-paper'
import BasicLayout from '../components/basic-layout/index.vue'
import BookSelector from '../components/book-selector'
import AssessmentTarckMixin from '../mixins/assessment-track-mixin'
import RouterMixin from '../mixins/router-mixin'
import { getBaseInfo, getCpList, getDefaultbook, getUnits } from '../model/api'
import { SUBJECT_TYPE_LIST } from '../model/publish'

const proSource = '精品卷库'

@Component({
  components: { AssessmentPaper, BasicLayout, BookSelector, Ranger, PaperPending, SmallBtnSkeleton }
})
export default class AssessmentLib extends Mixins(AssessmentTarckMixin) {
  // 试卷列表信息
  private paperList = []
  private page = 1
  private sum = 0
  private perPage = 10
  private loading = true
  // 测评类型
  private examTypeList: any[] = []
  // 默认选中全部
  private examType = { type: '', typeName: '全部' }
  // 题目分类
  private subjectTypes = []
  private subjectTypeList = SUBJECT_TYPE_LIST
  // 班级列表
  private defaultBook = {}
  private selectedBook = {
    bookName: '',
    bookId: ''
  }
  private unitId = ''
  private unitCName = ''
  private unitList = [{ cname: '请选择', unitId: '' }]
  private selectorVisible = false
  private start = ''
  private end = ''
  // 新增筛选项
  private provinceChoice = [{ code: 0, name: '全部' }]
  private yearChoice = [['', '全部']]
  private province = { code: 0, name: '全部' }
  private year = ['', '全部']
  private keyword = ''
  private usenumStatus = 'down'
  private usenumSelected = false
  private updateStatus = 'down'
  private updateSelected = true
  // 默认展开
  private flag = true
  private optionsLoading = true
  // 获取学科信息
  private get subject() {
    return this.$store.state.subject
  }
  // 获取班级测评列表
  private get clazzLevelList() {
    const subjectLeaderList = this.$store.state.supportSubjects
    if (this.subject && this.subject.nick) {
      const CSubject = subjectLeaderList.find((m) => {
        return m.nick === this.subject.nick
      })
      return CSubject && CSubject.clazzLevels
    }
    return []
  }
  // 用户地区
  private get regions() {
    return this.$store.state.user_info && this.$store.state.user_info.regions
  }
  // 支持的学科
  private get supportSubjects() {
    return this.$store.state.supportSubjects
  }
  // 展示状态
  public get switchTemplate() {
    if (this.loading) {
      return 'pending'
    } else {
      if (this.paperList && this.paperList.length > 0) {
        return 1
      } else {
        return 2
      }
    }
  }

  @Watch('subject', { deep: true, immediate: true })
  public onSubjectChange(val) {
    console.log(val)
    this.keyword = ''
    this.year = ['', '全部']
    if (val && val.nick) {
      this.getInitInfo()
      this.getDefaultbook()
    }
  }
  @Watch('supportSubjects')
  public onSupportSubjectsChange(val) {
    // assessment页面因为需要能跳转过来，所以要在这里进行权限判断。
    if (this.supportSubjects && this.supportSubjects.length > 0) {
      // 对学科进行判断，老师的学科如果在允许的学科中就可以使用测评
      const arr = this.supportSubjects.filter((n) => {
        return AssessmentAllowSubjects.find((item) => item.value == n.value)
      })
      if (arr && arr.length) {
        console.log('pass')
      } else {
        this.$router.replace({ path: '/assessment/intro' })
      }
    } else {
      this.$router.replace({ path: '/assessment/intro' })
    }
    this.page = 1
    // this.getInitInfo()
    this.getBaseInfo()
  }
  // mount
  public created() {
    // this.page = 1
    // this.getInitInfo()
    // this.getBaseInfo()
  }
  // 题目分类勾选
  public onSubjectTypesChange(checkedVals) {
    // 筛选
    this.getPaperList((this.page = 1))
  }
  // 是否选中
  public judgeSelected(itm, temp): boolean {
    return itm.type === temp.type
  }
  public onPageChange(page: number): void {
    this.page = page
    this.getPaperList(page)
  }
  public clickExamType(itm): void {
    if (itm && itm.type === 'UNIT_TEST' && this.unitList && this.unitList.length > 1) {
      this.unitId = this.unitList[1].unitId
      this.unitCName = this.unitList[1].cname
    }
    this.examType = itm
    this.page = 1
    this.getPaperList(this.page)
  }
  // 获取地区、年份
  public async getInitInfo() {
    try {
      this.optionsLoading = true
      const data: any = await getInitInfo({ subject_id: this.subject.value, isCls: 0 })
      if (data.success) {
        this.provinceChoice = [{ code: 0, name: '全部' }, ...data.data.region_choices]
        const yearChoice = data.data.cp_paper_years.map((m) => {
          return [m, m]
        })
        this.yearChoice = [['', '全部'], ...yearChoice]
      }
    } catch (e) {
      console.log(e)
    } finally {
      this.optionsLoading = false
    }
  }
  // 获取基础信息
  public async getBaseInfo() {
    try {
      const data: any = await getBaseInfo({})
      if (data.success) {
        this.examTypeList = [{ type: '', typeName: '全部' }, ...data.examTypeList]
      }
    } catch (e) {}
  }
  // 获取默认教材
  public async getDefaultbook() {
    try {
      const data: any = await getDefaultbook({ subject: this.subject.nick })
      if (data.success) {
        this.defaultBook = data.defaultBook
        this.selectedBook = {
          bookName: data.defaultBook && data.defaultBook.bookName,
          bookId: data.defaultBook && data.defaultBook.bookId
        }
        this.unitList = [{ cname: '请选择', unitId: '' }, ...data.defaultBook.unitList]
        const defaultUnit: any = this.unitList.find((itm: any) => itm.defaultUnit)
        if (
          this.examType &&
          this.examType.type === 'UNIT_TEST' &&
          this.unitList &&
          this.unitList.length > 1
        ) {
          this.unitId = this.unitList[1].unitId
          this.unitCName = this.unitList[1].cname
        } else {
          this.unitId = ''
          this.unitCName = '请选择'
        }
        console.log(1)
        this.page = 1
        this.getPaperList(this.page)
      }
    } catch (e) {}
  }
  public async getUnits() {
    const data: any = await getUnits({
      bookId: this.selectedBook.bookId || ''
    })
    if (data.success) {
      this.unitList = [{ cname: '请选择', unitId: '' }, ...data.book.unitList]
      const defaultUnit: any = this.unitList.find((itm: any) => itm.defaultUnit)
      if (
        this.examType &&
        this.examType.type === 'UNIT_TEST' &&
        this.unitList &&
        this.unitList.length > 1
      ) {
        this.unitId = this.unitList[1].unitId
        this.unitCName = this.unitList[1].cname
      } else {
        this.unitId = ''
        this.unitCName = '请选择'
      }
      this.page = 1
      this.getPaperList(this.page)
    }
  }
  // 选择单元
  public onUnitSelect(value, option) {
    this.unitId = value
    this.page = 1
    this.getPaperList(this.page)
  }
  public showSelector() {
    this.selectorVisible = true
  }
  public onSelectorOK(val) {
    this.selectorVisible = false
    this.selectedBook = val && val.length > 0 ? val[0] : { bookName: '', bookId: '' }
    if (this.selectedBook && this.selectedBook.bookId) {
      this.getUnits()
    } else {
      this.unitList = [{ cname: '请选择', unitId: '' }]
      this.unitId = ''
      this.unitCName = ''
      this.page = 1
      this.getPaperList(this.page)
    }
  }
  public onSelectorCancel() {
    this.selectorVisible = false
  }
  public async getPaperList(page) {
    let sort_way = '-updated_at'
    if (this.updateSelected) {
      if (this.updateStatus === 'up') {
        sort_way = 'updated_at'
      } else {
        sort_way = '-updated_at'
      }
    }
    if (this.usenumSelected) {
      if (this.usenumStatus === 'up') {
        sort_way = 'exam_use_num'
      } else {
        sort_way = '-exam_use_num'
      }
    }
    let params: any = {
      page,
      subject_id: this.subject.value,
      main_question_types: this.subjectTypes,
      num_start: Number(this.start),
      num_end: Number(this.end),
      use_type: this.examType && this.examType.type,
      // 新增字段
      year: this.year && this.year.length && this.year[0],
      region_code: this.province && this.province.code,
      name: this.keyword && this.keyword,
      sort_way
    }
    if (
      this.examType &&
      this.examType.type === 'UNIT_TEST' &&
      this.unitList &&
      this.unitList.length > 1
    ) {
      params.book_catalog_id = this.unitId ? String(this.unitId) : String(this.selectedBook.bookId)
    } else {
      params.book_catalog_id = String(this.selectedBook.bookId)
    }
    try {
      this.loading = true
      const data: any = await getCpList(params)
      if (data.success) {
        this.paperList = data.data.papers.map((itm) => {
          itm.paper = JSON.parse(JSON.stringify(itm))
          return itm
        })
        this.sum = data.data.total
      } else {
        this.paperList = []
      }
    } catch (e) {
      console.log(e)
    } finally {
      this.loading = false
    }
  }
  public onInputBlur() {
    this.getPaperList((this.page = 1))
  }

  public publish(data) {
    this.trackPublish('去发布', proSource)
    setTimeout(() => {
      this.$router.push({
        path: '/assessment/publish',
        query: {
          subject: this.subject.nick,
          subject_id: this.subject.value,
          pid: data.paper.old_paper_id,
          s: 'QUESTION_BANK',
          f: encodeURIComponent(proSource)
        }
      })
    }, 100)
  }
  public preview(data) {
    this.trackPublish('试卷预览', proSource)
    setTimeout(() => {
      this.$router.push({
        path: '/assessment/paper',
        query: {
          _id: data.paper_id,
          subject: this.subject.nick,
          subject_id: this.subject.value,
          s: 'QUESTION_BANK',
          paper: encodeURIComponent(JSON.stringify(data))
        }
      })
    }, 100)
  }
  // 点击展开/收起
  public switchIt(val: boolean) {
    this.flag = !this.flag
  }
  // 地区
  public clickRegion(item) {
    this.province = item
    this.getPaperList((this.page = 1))
  }
  public clickYear(item) {
    this.year = item
    this.getPaperList((this.page = 1))
  }
  // 清空输入内容时自动检索
  public onKeywordChange() {
    if (this.keyword === '') {
      this.getPaperList((this.page = 1))
    }
  }
  // 点击搜索
  public onSearch() {
    this.getPaperList((this.page = 1))
  }
  // sorter ranger
  public onUsenumChange(val) {
    this.usenumStatus = val
    this.getPaperList((this.page = 1))
  }
  public onSelectUsenum() {
    this.usenumSelected = true
    this.updateSelected = false
    this.getPaperList((this.page = 1))
  }
  public onUpdateChange(val) {
    this.updateStatus = val
    this.getPaperList((this.page = 1))
  }
  public onSelectUpdate() {
    this.updateSelected = true
    this.usenumSelected = false
    this.getPaperList((this.page = 1))
  }
  public reload() {
    location.reload()
  }
}
